import { useTranslation } from 'react-i18next'

import { Select } from '@/components/ui/Select'
import { ROUTE_POINT_KINDS, type RoutePointKind } from '@/types/domain'

/* The kind of a route point (migration 0062) as one control, shared by the
 * three editors that write points: a quote's route option, a case leg's chain
 * and a Settings direction. One component so the three cannot offer different
 * vocabularies for the same stored value. */
export function PointKindSelect({
  value,
  onChange,
  ariaLabel,
  className,
}: {
  value: RoutePointKind
  onChange: (kind: RoutePointKind) => void
  ariaLabel: string
  className?: string
}) {
  const { t } = useTranslation()
  return (
    <Select
      value={value}
      onChange={onChange}
      aria-label={ariaLabel}
      className={className}
      options={ROUTE_POINT_KINDS.map((kind) => ({
        value: kind,
        label: t(`routePoints.kinds.${kind}`),
      }))}
    />
  )
}
